import $ from 'jquery';
import 'bootstrap/js/dist/collapse';
import GaTracking from '../core/components/ga-tracking';
export default class CollapsibleFooter {
    static $element = $('.js__collapsible-footer');
    static init() {
        this.$element.on('show.bs.collapse', () => {
            GaTracking.pushDataLayer({
                event: 'storeLocatorMoreInformationCollapse',
                storeLocatorMoreInformationCollapseValue: 'Open',
            });
        });
        this.$element.on('hidden.bs.collapse', () => {
            GaTracking.pushDataLayer({
                event: 'storeLocatorMoreInformationCollapse',
                storeLocatorMoreInformationCollapseValue: 'Close',
            });
        });
    }
}
